
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
interface BannerItem {
  link: string,
  path: string,
  remark?: string
}
@Component({
  name: 'index',
  components: {
  }
})
export default class extends Vue {
  public bannerVideo = 'https://cosimg.geteducation.net/index/gea-system.mp4';
  public videoOpen = false;
  public previewMuted = true;

  public getLang() {
    return AppModule.language;
  }
  get brandName() {
    const { company } = this.$route.query;
    const currentCompany = Array.isArray(company) ? company[0] || '' : company || '';
    return currentCompany.toUpperCase() === 'GEA' ? 'GEA' : 'GET';
  }
  get isMobile() {
    return AppModule.narrow;
  }

  public togglePreviewSound() {
    const video = this.$refs.previewVideo as HTMLVideoElement | undefined;
    if (!video) {
      return;
    }
    this.previewMuted = !this.previewMuted;
    video.muted = this.previewMuted;
    video.defaultMuted = this.previewMuted;
    if (!this.previewMuted) {
      video.volume = 1;
    }
    const playPromise = video.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(() => undefined);
    }
  }

  public openVideo() {
    this.videoOpen = true;
    this.$nextTick(() => {
      const video = this.$refs.lightboxVideo as HTMLVideoElement | undefined;
      if (video) {
        video.muted = false;
        video.play().catch(() => undefined);
      }
    });
  }

  public closeVideo() {
    const video = this.$refs.lightboxVideo as HTMLVideoElement | undefined;
    if (video) {
      video.pause();
    }
    this.videoOpen = false;
  }

  public mounted() {
    this.playPreview();
    document.addEventListener('WeixinJSBridgeReady', this.onWeixinReady, false);
  }

  public beforeDestroy() {
    document.removeEventListener('WeixinJSBridgeReady', this.onWeixinReady, false);
  }

  public playPreview() {
    this.$nextTick(() => {
      const video = this.$refs.previewVideo as HTMLVideoElement | undefined;
      if (!video) {
        return;
      }
      video.muted = this.previewMuted;
      video.defaultMuted = this.previewMuted;
      (video as any).playsInline = true;
      video.setAttribute('muted', 'muted');
      video.setAttribute('playsinline', 'true');
      video.setAttribute('webkit-playsinline', 'true');
      const isWechat = /MicroMessenger/i.test(navigator.userAgent);
      if (!isWechat) {
        this.startMutedPlay(video);
        return;
      }
      const bridge = (window as any).WeixinJSBridge;
      if (bridge && bridge.invoke) {
        bridge.invoke('getNetworkType', {}, () => {
          this.startMutedPlay(video);
        });
      }
    });
  }

  public startMutedPlay(video: HTMLVideoElement) {
    const run = () => {
      video.muted = this.previewMuted;
      const playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => undefined);
      }
    };
    run();
    if (video.readyState < 2) {
      video.addEventListener('canplay', run, { once: true });
    }
  }

  private onWeixinReady = () => {
    this.playPreview();
  };
}
